export default __webpack_public_path__ + "images/resize.f3defc7bd5a3e4e9a44c2a8e10bd1272.svg";